import { render, staticRenderFns } from "./ProfessionalLabel.vue?vue&type=template&id=23bfd0ce&scoped=true"
import script from "./ProfessionalLabel.vue?vue&type=script&lang=js"
export * from "./ProfessionalLabel.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalLabel.vue?vue&type=style&index=0&id=23bfd0ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfd0ce",
  null
  
)

export default component.exports